import ShowIcon from '@/components/icons/ShowIcon';
import ViewOffSlashIcon from '@/components/icons/ViewOffSlashIcon';
import { Button } from '@/components/ui/button';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import CurrentBalanceSkeleton from './CurrentBalanceSkeleton';
import { useFinancesBalanceSummaryApi } from '@/features/finances/hooks/useFinancesBalanceSummaryApi';
import CurrencyValue from '../CurrencyValue';

type Props = {
    className?: string;
    isMobile?: boolean;
};

const FinancesPageBalance: FC<Props> = ({ className, isMobile }) => {
    const [showBalance, setShowBalance] = useState<boolean>(true);
    const { t } = useTranslation();

    const { balanceSummaryData, isLoadingBalanceSummaryData } = useFinancesBalanceSummaryApi();

    const hiddenBalance = (
        <div className={cn('h-8 flex items-center gap-1', isMobile && 'h-7')}>
            {Array.from({ length: 8 }).map((_, index) => (
                <div key={index} className="size-2 bg-black rounded-full" />
            ))}
        </div>
    );

    return (
        <div
            className={cn(
                'w-full p-6 flex flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10 truncate',
                isMobile && 'p-0 border-0 bg-popover-30 h-auto gap-4',
                className,
            )}
        >
            <div className="flex items-center justify-between gap-4">
                <h4 className={cn('text-xl font-medium', isMobile && 'text-lg')}>
                    {t('main.finances.components.balance.title')}
                </h4>
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => setShowBalance((prev) => !prev)}
                >
                    {showBalance ? <ShowIcon /> : <ViewOffSlashIcon />}
                </Button>
            </div>
            <div className="relative truncate">
                <div className="px-6 py-5 flex flex-col items-center justify-center bg-popover-50 rounded-xl border border-popover-50 truncate">
                    {isLoadingBalanceSummaryData && <CurrentBalanceSkeleton isMobile={isMobile} />}
                    {!isLoadingBalanceSummaryData && (
                        <>
                            {showBalance === false ? (
                                hiddenBalance
                            ) : (
                                <span
                                    className={cn(
                                        'text-2xl font-medium truncate',
                                        isMobile && 'text-lg',
                                    )}
                                >{<CurrencyValue value={balanceSummaryData?.balance || 0} asset='other' />}</span>
                            )}
                            <span className="text-sm text-popover-600 truncate">
                                {t('main.finances.components.balance.currentBalance')}
                            </span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FinancesPageBalance;
